import { DELETE_USER, SET_LOADING, UPDATE_USERS } from './actions/users'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { user_types } from '@/datas/consts'
const approvementsApi = RepositoryFactory.get('approvements')
const Users = RepositoryFactory.get('users')
const FETCH_USERS_STATS = 'FETCH_USERS_STATS'

export default {
  namespaced: true,
  state: {
    users: [],
    pagination: {},
    loading: false,
    approvStatistics: {},
  },
  getters: {
    getUsers: state => state.users,
    getPagination: state => state.pagination,
    getLoading: state => state.loading,
  },
  actions: {
    fetchUsers({ commit }, data) {
      commit(SET_LOADING, true)
      Users.getUsers(data)
        .then(res => commit(UPDATE_USERS, res.data))
        .catch(() => commit(SET_LOADING, false))
    },
    async fetchDriversStats({ commit }) {
      commit(SET_LOADING, true)
      try {
        const { data } = await approvementsApi.fetchApprovements('users')

        commit(FETCH_USERS_STATS, data.by_meaning)
      } catch (err) {
        console.log(err)
      } finally {
        commit(SET_LOADING, false)
      }
    },
  },
  mutations: {
    [FETCH_USERS_STATS](state, payload) {
      state.approvStatistics = payload
    },
    [UPDATE_USERS]: (state, { items, _meta }) => {
      state.users = items.filter(d => {
        d.user_type = user_types[d.user_type]

        return true
      })
      state.pagination = _meta
      state.loading = false
    },
    [DELETE_USER]: (state, { id }) => {
      state.users.splice(
        state.users.findIndex(i => i.id === id),
        1,
      )
    },
    [SET_LOADING]: (state, flag) => {
      state.loading = Boolean(flag)
    },
  },
}
